import { useMemo } from 'react';
import useColorPalette from '../../hooks/useColorPalette';

export type DataTypes = 'datafiles' | 'datasets' | 'model-families' | 'batch-predictions' | 'single-predictions' | 'readacross' | 'jobs';

const getTitleAndMessage = (dataType: DataTypes) => {
    let message = '';
    let title = '';

    switch(dataType) {
        case 'datafiles':
            title = 'No files';
            message = `Files that you've uploaded will be displayed here. Click on "+ Upload File" at the top right corner to upload a new file.`;
            break;
        case 'datasets':
            title = 'No datasets';
            message = `Datasets that you've generated will be displayed here. Click on "+ Generate Dataset" at the top right corner to generate a new dataset.`;
            break;
        case 'model-families':
            title = 'No model families';
            message = `Models that you've trained will be displayed here. Click on "+ Train Model" at the top right corner to train a new model. `;
            break;
        case 'batch-predictions':
            title = 'No batch predictions';
            message = `Batch predictions that you've generated will be displayed here. Click on the "Run Prediction" dropdown at the top right corner and select "Batch Prediction" to run a new set of predictions.`;
            break;
        case 'single-predictions':
            title = 'No single predictions';
            message = `Single predictions that you've generated will be displayed here. Click on the "Run Prediction" dropdown at the top right corner and select "Single Compound Prediction" to run a new prediction.`;
            break;
        case 'readacross':
            title = 'No read-across predictions';
            message = `Read-across predictions that you've generated will be displayed here. Click on "+ Generate Read-Across" at the top right corner to run a new read-across prediction.`;
            break;
        case 'jobs':
            title = 'No jobs';
            message = `There are currently no jobs in the queue.`;
            break;
        default:
            title = '';
            message = '';
            break;
    };

    return {
        message,
        title,
    }
}

export default function EmptyTable({
    dataType,
}: {
    dataType: DataTypes,
}) {
    const { palette } = useColorPalette(); 
    const { title, message } = useMemo(() => getTitleAndMessage(dataType), [dataType])

    return (
        <div className="w-full flex flex-col justify-center items-center gap-6 text-default">
            <img src={`${process.env.PUBLIC_URL}/no-docs/${palette.logo}`} className="w-[150px]" alt='no-docs'/>
            <div className="flex flex-col gap-2 justify-center items-center">
                <p className="text-[18px] font-semibold text-primary">{title}</p>
                <p className="text-quaternary font-normal max-w-[600px] text-center">{message}</p>
            </div>
        </div>
    )
}